import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-messages',
  templateUrl: './about-messages.component.html',
  styleUrls: ['./about-messages.component.css']
})
export class AboutMessagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
